var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgClock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00287 1.88C5.00844 1.9457 4.98675 2.01079 4.9429 2.06L1.06513 5.93C1.0176 5.97751 0.952345 6.0029 0.885228 6C0.814067 5.99847 0.746163 5.96986 0.695337 5.92C-0.297748 4.72914 -0.219912 2.97719 0.874863 1.87919C1.96964 0.781195 3.72039 0.699168 4.91292 1.69C4.96643 1.73924 4.99869 1.80738 5.00287 1.88ZM10 3C5.03229 3 1.00516 7.02944 1.00516 12C1.00516 16.9706 5.03229 21 10 21C14.9677 21 18.9948 16.9706 18.9948 12C18.9948 7.02944 14.9677 3 10 3ZM10 19C6.13622 19 3.00401 15.866 3.00401 12C3.00401 8.13401 6.13622 5 10 5C13.8638 5 16.996 8.13401 16.996 12C16.996 15.866 13.8638 19 10 19ZM16.996 1C16.2954 0.998632 15.6165 1.24276 15.0771 1.69C15.0236 1.73924 14.9913 1.80738 14.9871 1.88C14.9842 1.94716 15.0096 2.01245 15.0571 2.06L18.9349 5.94C18.9824 5.98751 19.0477 6.0129 19.1148 6.01C19.1873 6.00582 19.2555 5.97354 19.3047 5.92C20.0497 5.025 20.2096 3.77937 19.7149 2.725C19.2201 1.67062 18.1601 0.998107 16.996 1ZM10.8795 7.5V11.64L13.7978 14.56C13.8924 14.6539 13.9456 14.7817 13.9456 14.915C13.9456 15.0483 13.8924 15.1761 13.7978 15.27L13.2681 15.8C13.1743 15.8947 13.0466 15.9479 12.9133 15.9479C12.7801 15.9479 12.6524 15.8947 12.5585 15.8L9.27042 12.51C9.17884 12.4159 9.12542 12.2912 9.1205 12.16V7.5C9.1205 7.22386 9.34423 7 9.62022 7H10.3798C10.6558 7 10.8795 7.22386 10.8795 7.5Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clock.1440bc6c.svg";
export { ForwardRef as ReactComponent };